import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/database';
import _ from 'lodash'
import format from 'date-fns/format'
import {globalfunc} from '../globalfunc.js';
import countriesAndTimezone from 'countries-and-timezones';
import reward from './reward.js';
import addMinutes from 'date-fns/add_minutes';
import addHours from 'date-fns/add_hours';
import subHours from 'date-fns/sub_hours';
const apiUrl='https://api-node.happily.ai'
import { getCompany } from './core/cacheService'
class Convert {
  time: any;
  constructor (message: any) {
      this.time = message;
  }
  convertTime() : any {
    let timeC = this.time;
    let hours = Number(timeC.match(/^(\d+)/)[1]);
    let minutes = Number(timeC.match(/:(\d+)/)[1]);
    let AMPM = timeC.match(/\s(.*)$/)[1];
    console.log("AMPM",AMPM)
    console.log("minutes",minutes)
    console.log("hours",hours)

    if(AMPM == "PM" && hours<12) hours = hours+12;
    if(AMPM == "AM" && hours==12) hours = hours-12;
    let sHours = hours.toString();
    let sMinutes = minutes.toString();
    if(hours<10) sHours = "0" + sHours;
    if(minutes<10) sMinutes = "0" + sMinutes;
    return sHours + ":" + sMinutes;
  }
} 
export default {
    namespaced: true,
    state: {
        timeZoneOption:[],
        locationOption:[],
        timezone:[],
        rewardMaster:[]
    },
    mutations: {
        setTimeZoneOption(state:any, result:any) {
            state.timeZoneOption = result
          },
          setTimezone(state:any, result:any) {
            state.timezone = result
          },
          setLocationOption(state:any, result:any) {
            state.locationOption = result
          },
          setRewardMaster(state:any, result:any) {
            state.rewardMaster = result
          },
    },
    actions: {
    async register({ commit, rootState, state, dispatch }: any, value: any){

        var data = {
            name:value.companyName,
            address:"",
            reward_note: "",
            reward_note_th: "",
            billing_currency: "THB",
            rate: 0,
            country:value.location,
            email_type:"html",
            gen_question: "Y",
            starttime: "08:00",
            starttime_show: "08:00",
            starttime_timezone: "08:00",
            reminder:"Y",
            reminder_time:"18.00",
            report_dailyboss:"Y",
            report_dailyboss_time:"08.30",
            report_weeklyboss:"Y",
            report_weeklyboss_time:"08.30",
            report_weeklyuser:"Y",
            report_weeklyuser_time:"08.15",
            coaching:"Y",
            coaching_time:"10:30",
            report_monthlyboss:"N",
            report_activity_manager:"N",
            qrcode:"Y",
            leadership:"Y",
            create_sessions:"Y",
            spark :'Y',
            house_village :'Y',
            create_topics : 'Y',
            townhall :'Y',
            peer_feedback : 'Y',
            huddles:'N',
            feedback_to_leader :'N',
            show_integration :'N',
            birthday :'Y',
            assist_access:'false',
            recharge_powerup : 'Y',
            follow_message : 'Y',
            ai_reply : 'Y',
            timezone:parseInt(state.timezone[value.timeZone].utcOffsetStr),
            updated:  format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            createdate: format(new Date(), 'YYYY-MM-DD HH:mm:ss'),
            feed_logo:'',
            village_logo:'',
            balloon_logo:'',
            status:"Y",          
            rewards_manage:"happily"
        }

        //let newId:any = firebase.database().ref('company').push().key;
        
        // let insert = {};
        // insert[newId] = data;
        // console.log("insert",insert)
       // await firebase.database().ref('company').update(insert);
        
        // let name=value.name.split(" ")


        // let dataUser={
        //     country:value.location,
        //     email:value.email,
        //     language:value.language,
        //     firstname:name[0].trim(),
        //     lastname:name[1].trim(),
        //     company:newId,
        //     team:"",
        //     boss:"",
        //     user_type:"superadmin",
        //     gem:0,
        //     coin:0,
        //     powerup:{
        //       fivecoins:"14",
        //       threecoins:"7",
        //     },
        //     profilepic:"",
        //     address:"",
        //     mobile:"",
        //     phone:"",
        //     updated:format(new Date(), 'YYYY-MM-DD HH:mm'),
        //     createdatetime:format(new Date(), 'YYYY-MM-DD HH:mm'),
        //     modifydatetime:format(new Date(), 'YYYY-MM-DD HH:mm')
        // }
        // let insertUser = {};
        // let emailKey=value.email.replace(/\./g, "||");
        // insertUser[emailKey] = dataUser;
        // console.log("emailKey",insertUser[emailKey])
       // await firebase.database().ref('users').update(insertUser);
       // dispatch("auth/login", {email: value.email});

       var axios = require('axios');
       var url=""
       var optionData:Array<any> = [];
       let currentDate= format(new Date(), 'YYYY')
       
       var config = {
         method: 'POST',
         url: apiUrl+`/freetrial`,
         headers: {
           'Access-Control-Allow-Origin': '*',
           'Access-Control-Allow-Credentials': 'true',
           'Access-Control-Allow-Headers': 'Content-Type, Authorization',
           'Access-Control-Allow-Methods' : 'GET, POST, OPTIONS',
         },
         data: {
          company: data,
          ...value
          // email:value.email,
          // name:value.name
        },
       };
       
       axios(config)
       .then(function (response) {
         const data = response.data

         console.log("data",data)

         dispatch("auth/login", {email: value.email,freetrial:true}, {root:true});
       })
       .catch(function (error) {
         console.log(error);
       });


    },
    getTimezone({ commit, rootState, state, dispatch }: any, value: any){
        let timezone=countriesAndTimezone.getAllTimezones()
        let countries=countriesAndTimezone.getAllCountries()
        let optionsTimezone:Array<any>=[]
        let locationOption:Array<any>=[]
        for(let value in timezone){
            optionsTimezone.push( { lable: value,value: value})
        }
        for(let value in countries){
            locationOption.push( { lable: value,value: countries[value].name})
        }
        locationOption=_.sortBy(locationOption, [
            function(o) {
              return o.value;
            }
          ]);
          optionsTimezone=_.sortBy(optionsTimezone, [
            function(o) {
              return o.value;
            }
          ]);
        commit('setTimeZoneOption',optionsTimezone)
        commit('setLocationOption',locationOption)
        commit('setTimezone',timezone)
       
    },
    async registerMember({ commit, rootState, state, dispatch }: any, value: any){
        console.log("value",value)
        console.log("rootState.authen.user",rootState.authen.user)
        let insertUser = {};
        let rewards_company={}
        const dateNow = new Date()
       
        const companyData = await getCompany(rootState.authen.user.company)
        if(rootState.authen.user.email){
          let email_Key=rootState.authen.user.email.replace(/\./g, "||");
          var userData = rootState.main.allUser[email_Key]//(await firebase.database().ref(`/users/${email_Key}`).once('value')).val()
        }
        //manager
        let name=value.manager.managerName.split(" ")
        let dataUser={
         country:userData.country,
         email:value.manager.emailManager,
         language:userData.language,
         firstname:name[0].trim(),
         lastname:name[1].trim(),
         company:rootState.authen.user.company,
         team:"",
         boss:"",
         user_type:"superleader",
         gem:0,
         coin:0,
         powerup:{
           fivecoins:"14",
           threecoins:"7",
         },
         profilepic:"",
         address:"",
         mobile:"",
         phone:"",
         updated: format(new Date(), 'YYYY-MM-DD HH:mm'),
         createdatetime: format(new Date(), 'YYYY-MM-DD HH:mm'),
         modifydatetime: format(new Date(), 'YYYY-MM-DD HH:mm'),
     }
 
        
     
     let emailKey=value.manager.emailManager.replace(/\./g, "||");
     insertUser[emailKey] = dataUser;


        value.members.map(v=>{
          console.log("v",v)
        if(v.name){
          let name=v.name.split(" ")
          let dataUser={
           country:userData.country,
           email:v.email,
           language:userData.language,
           firstname:name[0].trim(),
           lastname:name[1].trim(),
           company:rootState.authen.user.company,
           team:"",
           boss:"",
           user_type:"superadmin",
           gem:0,
           coin:0,
           powerup:{
             fivecoins:"14",
             threecoins:"7",
           },
           profilepic:"",
           address:"",
           mobile:"",
           phone:"",
           updated: format(new Date(), 'YYYY-MM-DD HH:mm'),
           createdatetime: format(new Date(), 'YYYY-MM-DD HH:mm'),
           modifydatetime: format(new Date(), 'YYYY-MM-DD HH:mm'),
       }
   
          
       
       let emailKey=v.email.replace(/\./g, "||");
       insertUser[emailKey] = dataUser;

      }})
         
         firebase.database().ref('users').update(insertUser);
         rewards_company[`rewards_company/${rootState.authen.user.company}`] =state.rewardMaster
         console.log("rewards_company",rewards_company)
         firebase.database().ref().update(rewards_company);

         let coreValue={}
         let starttime=''
         let starttime_timezone = ''

         for(var i in value.recognitionValue){
          let _id=firebase.database().ref(`company/${rootState.authen.user.company}/hashtag`).push().key;
          if(_id) 
          coreValue[_id]={
             name:value.recognitionValue[i].label,
             name_th:value.recognitionValue[i].label,
           }
         }
         if(companyData.timezone){

         const setlengthTimezone = [];
         setlengthTimezone['7'] = [4, 4.5, 5, 5.5, 5.75, 6, 6.5, 7, 8, 9, 9.5, 10];
         setlengthTimezone['-7'] = [-4, -5, -6, -7, -8, -9, -10];
         setlengthTimezone['0'] = [-3.5, -3, -2, -1, 0, 1, 2, 3, 3.5];
         let globalTime = 0
         if (setlengthTimezone['7'].indexOf( parseFloat(companyData.timezone)) !== -1)
             globalTime = 7;
         if (setlengthTimezone['-7'].indexOf( parseFloat(companyData.timezone)) !== -1)
             globalTime = -7;
         if (setlengthTimezone['0'].indexOf( parseFloat(companyData.timezone)) !== -1)
         globalTime = 0;

         let diffTimezone = companyData.timezone - globalTime
         let convert_1 = new Convert(value.gen_question);
         let starttimeSave = convert_1.convertTime();
          const DailyPulse:any = starttimeSave.split(":")
          const starttimeTimezone = starttimeSave.split(":");
         starttime = format(subHours(dateNow.setHours(DailyPulse[0], DailyPulse[1]),diffTimezone), 'HH:mm')     
         starttime_timezone = format(dateNow.setHours(starttimeTimezone[0], starttimeTimezone[1]), 'HH:mm')
        }
         let updateCompany={
          hashtag_status:true,
          hashtag:coreValue,
          starttime:starttime,
          starttime_show:starttime,
          starttime_timezone:starttime_timezone
         }
          console.log("updateCompany",updateCompany)
         firebase.database().ref(`company/${rootState.authen.user.company}`).update(updateCompany);




    },
    async rewardMaster({ commit, rootState, state, dispatch }: any, value: any){
      let companyReward={}
      firebase.database().ref('rewards').orderByChild("company").equalTo('global').once('value', snapshot => {
        snapshot.forEach((arrData) => {
          const _data = arrData.val()
          if(_data.newtype=="Company Reward" && _data.status=="Y"){
              _data.status="Y"
              _data.show="Y"
              
              if(arrData.key){companyReward[arrData.key]=_data}
          }
        })
        commit('setRewardMaster',companyReward)
        
    })
    },
    async inviteMember({ commit, rootState, state, dispatch }: any, value: any){
      let insert = {};
      if(value.manager.emailManager!=rootState.authen.user.email){
        
        const newId = firebase.database().ref().child('user_invite').push().key;     
        const data = {
          email:value.manager.emailManager
      };
        if(newId){
          insert[newId] = data;
        }

      }
      value.members.map(v=>{
       // console.log("v",v)
      if(v.name){
        if(v.email!=rootState.authen.user.email){

          const newId = firebase.database().ref().child('user_invite').push().key;     
          const data = {
            email: v.email
        };
        if(newId){
          insert[newId] = data;
        }
      }
      }})
      firebase.database().ref('user_invite').update(insert);
    }

    
  },
    getters: {
        timeZoneOption : (state:any) => {
            return state.timeZoneOption
          },
          locationOption : (state:any) => {
            return state.locationOption
          },
    }
}